import React, { Component } from 'react';
import styled from 'styled-components';
import { media } from '../../helpers/styleConstants';
import { Button, Card, CardPrimaryAction, Icon, Tab, TabBar, Typography } from 'rmwc';
import { Text } from '../Text';
import { PlanScorePanel } from '../../containers/PlanScorePanel';
import { ScorecardOnboarding } from '../../components/charts/Scorecard';
import { PlanImpactSingleNoFrame } from '../../components/charts/PlanImpact';
import { scoreCardCopy } from '../../components/charts/scoreConstants';
import { ExpandableGroup, ExpandableItem } from '../../components/Expandable';
import { Money } from '../Money';
import { wlPath } from '../../helpers/whitelabel';

const CircularButtonRightCaret = styled.div`
  height: 40px;
  width: 40px;
  background: #00d29c;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export class ScoreVariantCurrent extends Component {
  render() {
    return (
      <div style={{ maxWidth: '900px' }} className="mb-4">
        <Text use="headline5" className="pt-4 mb-2">
          Your retirement Action Plan.
        </Text>

        <Text use="body1">
          We’ve evaluated <strong>25 areas</strong> of your finances and prepared a step-by-step plan to make your
          retirement better!
        </Text>

        <PlanScorePanel results={this.props.results} moneyLastsUntilAge={this.props.moneyLastsUntilAge} displayTabBar />

        <Text use="body1" className="mt-2">
          <a href="https://www.harborplan.com/methodology" target="_blank">
            See our methodology
          </a>{' '}
          for calculating these scores.
        </Text>
      </div>
    );
  }
}

export class ScoreTabbed extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTabIndex: 1,
    };
  }

  onTab = evt => {
    this.setState({ activeTabIndex: evt.target.value });
  };

  render() {
    return (
      <div>
        <TabBar
          className="ml-0 actionPlanIntro action-plan-tabs"
          activeTabIndex={this.state.activeTabIndex}
          onChange={this.onTab}
        >
          <Tab style={{ padding: 0, minWidth: 0, width: '134px' }}>Before my plan</Tab>
          <Tab style={{ padding: 0, minWidth: 0, width: '116px' }}>With my plan</Tab>
        </TabBar>
        <ScorecardOnboarding
          readinessGrade={this.props.results.scores.readiness_grade * 100}
          readinessGradeAfter={
            this.state.activeTabIndex == 0
              ? this.props.results.scores.readiness_grade * 100
              : Math.min(this.props.results.scores.readiness_grade * 110, 100)
          }
          secondaryLeftTitle={scoreCardCopy.RETIREMENT_SPENDING_POWER_TITLE}
          secondaryLeftFormat={scoreCardCopy.RETIREMENT_SPENDING_POWER_FORMAT}
          secondaryLeftAmountBefore={this.props.results.scores.retirement_spending_power}
          secondaryLeftAmountAfter={
            this.state.activeTabIndex == 0
              ? this.props.results.scores.retirement_spending_power
              : this.props.results.scores.retirement_spending_power * 1.1
          }
          secondaryLeftBenchmark={this.props.benchmarkLeft}
          secondaryRightTitle={scoreCardCopy.MONEY_LASTS_UNTIL_TITLE}
          secondaryRightFormat={scoreCardCopy.MONEY_LASTS_UNTIL_FORMAT}
          secondaryRightAmountBefore={this.props.moneyLastsUntilAge(this.props.results.scores.money_lasts_until)}
          secondaryRightAmountAfter={
            this.state.activeTabIndex == 0
              ? this.props.moneyLastsUntilAge(this.props.results.scores.money_lasts_until)
              : this.props.moneyLastsUntilAge(this.props.results.scores.money_lasts_until) + 2
          }
          reliabilityGrade={87}
        />
      </div>
    );
  }
}

const Arrow = styled.div`
  align-items: center;
  padding-top: 95px;
  width: 100px;

  ${media.phoneOnly`
    display: none !important;
  `};
`;

const StyledFirstScoreContainer = styled.div`
  align-items: center;

  ${media.phoneOnly`
    margin-right: -50px;
  `};
`;

const StyledText = styled(Text)`
  margin-bottom: 27px;

  ${media.phoneOnly`
    margin-bottom: 16px;
  `};
`;

export class ScoreSideBySide extends Component {
  render() {
    return (
      <div>
        <Typography use="headline5" tag="div" className="mt-4 mb-4">
          Your Financial Health Score
        </Typography>
        <div>
          <div className="hrbr-flex-columns--container" style={{ justifyContent: 'space-around' }}>
            <StyledFirstScoreContainer className="hrbr-flex-columns--column">
              <StyledText use="body1" theme="text-secondary-on-background">
                Current Score
              </StyledText>
              <div>
                <PlanImpactSingleNoFrame
                  healthCurrent={Math.min(this.props.results.scores.readiness_grade, 1) * 100}
                  healthTotal={Math.min(this.props.results.scores.readiness_grade, 1) * 100}
                  dollarsGainedTotal={0}
                  hideTotal
                  scores={this.props.results.scores}
                  small
                />
              </div>
              <div class="d-none text-center" style={{ marginTop: '-0.125rem' }}>
                <a href={wlPath('/score-methodology')} target="_blank">
                  <StyledText tag="span" use="body1" theme="text-secondary-on-background">See our Score Methodology</StyledText>
                </a>
              </div>
            </StyledFirstScoreContainer>
            <Arrow className="hrbr-flex-columns--column">
              <div className="hrbr-big-arrow" />
            </Arrow>
            <div className="hrbr-flex-columns--column" style={{ alignItems: 'center' }}>
              <Text use="body1" className="mb-0">
                <strong>Following our</strong>
              </Text>
              <Text use="body1" className="mb-1">
                <strong>Action Plan</strong>
              </Text>
              <div>
                <PlanImpactSingleNoFrame
                  healthCurrent={Math.min(this.props.results.scores.readiness_grade, 1) * 100}
                  healthSingle={Math.min(this.props.results.scores.target_readiness_grade * 100, 100)}
                  healthTotal={Math.min(this.props.results.scores.target_readiness_grade * 100, 100)}
                  dollarsGainedTotal={this.props.totalGain}
                  totalIsSingle={true}
                />
                <div class="text-center" style={{ marginTop: '-0.5rem' }}>
                  <a href={wlPath('/action-plan-value')} target="_blank">
                    <StyledText tag="span" use="body1" theme="text-secondary-on-background">See Calculation</StyledText>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
